import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { DayOfWeek } from '../models/notification-rule';
import { DayOfWeekTranslations } from '../models/common';

interface DayOfWeekSelectProps {
  value: DayOfWeek | undefined;
  onChange: (value: DayOfWeek) => void;
  labelText?: string;
  cssClass?: string;
  allowAny?: boolean;
  fullWidth?: boolean;
  variant?: 'outlined' | 'filled' | 'standard';
  disabled?: boolean;
  selectKey?: string;
}

const DayOfWeekSelect = ({
  value,
  onChange,
  labelText,
  cssClass,
  allowAny,
  fullWidth,
  variant,
  disabled,
  selectKey
}: DayOfWeekSelectProps) => {
  const { t } = useTranslation();
  const selectId = React.useId();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;
    // callback
    onChange && onChange(value);
  };

  const renderMenuItem = (day: DayOfWeek) => {
    return (
      <MenuItem value={day} key={`day-${Number(day)}`}>
        {t(DayOfWeekTranslations[day])}
      </MenuItem>
    );
  };

  return (
    <FormControl className={cssClass} disabled={disabled} size="small" fullWidth={fullWidth} variant={variant}>
      <InputLabel id={`${selectId}-label`}>{labelText || t('f-com-day-of-week')}</InputLabel>

      <Select
        label={labelText || t('f-com-day-of-week')}
        labelId={`${selectId}-label`}
        id={selectId}
        value={value}
        onChange={handleChange}
        key={`select-${selectKey}`}
      >
        {allowAny && (
          <MenuItem value={0} id="day-any">
            {t('f-any')}
          </MenuItem>
        )}

        {renderMenuItem(DayOfWeek.Monday)}
        {renderMenuItem(DayOfWeek.Tuesday)}
        {renderMenuItem(DayOfWeek.Wednesday)}
        {renderMenuItem(DayOfWeek.Thursday)}
        {renderMenuItem(DayOfWeek.Friday)}
        {renderMenuItem(DayOfWeek.Saturday)}
        {renderMenuItem(DayOfWeek.Sunday)}
      </Select>
    </FormControl>
  );
};

export default DayOfWeekSelect;
